import { FC } from "react";
import { Modal, Text } from "@mantine/core";
import { useStyles } from "../Regtank.styles";

interface MediaViewerModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  imageUrl?: string;
  videoUrl?: string;
  timestamp?: string;
}

/**
 * Unified modal for viewing images and videos
 * Used for both document photos and liveness checks
 */
export const MediaViewerModal: FC<MediaViewerModalProps> = ({
  opened,
  onClose,
  title,
  imageUrl,
  videoUrl,
  timestamp,
}) => {
  const { classes } = useStyles();

  return (
    <Modal
      classNames={{
        title: classes.modalTitle,
      }}
      title={title}
      opened={opened}
      onClose={onClose}
      size="xl"
      centered
    >
      <div className={classes.modalContainer}>
        {imageUrl && (
          <img
            className={classes.imageSize}
            src={imageUrl}
            alt={title}
          />
        )}
        {videoUrl && (
          <video className={classes.imageSize} autoPlay muted>
            <source src={videoUrl} type="video/mp4"></source>
          </video>
        )}
      </div>
      {timestamp && (
        <div
          style={{
            display: "flex",
            justifyContent: "right",
            marginTop: "15px",
          }}
        >
          <Text className={classes.subSmallText}>{timestamp}</Text>
        </div>
      )}
    </Modal>
  );
};
